import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { useAvaliacaoTreinamentoLoteCadastroViewModel } from "../../viewModels/avaliacao_treinamento_lote_cadastro_view_model";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendIcon } from "../../../../../common/components/legend_icon";
import { LegendItemComponent } from "../../../../../common/components/legend_item_component";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { AvaliarTreinamentoModal } from "./components/avaliar_treinamento_modal";
import { AvaliacaoTreinamento } from "../../../domain/models/avaliacao_treinamento";
import { useMemo } from "react";
import { GenerateTreinamentosColumnsDefinition } from "./columns/generate_treinamento";
import { Header } from "./components/header";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";

import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import PrimaryButton from "../../../../../common/components/primary_button";

/**
 * AvaliacaoTreinamentoLoteCadastro
 */

export const AvaliacaoTreinamentoLoteCadastro = () => {
  const viewModel = useAvaliacaoTreinamentoLoteCadastroViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateTreinamentosColumnsDefinition();
  }, []);

  return (
    <>
      {/**
        * TopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="w-[180px] ">
              <PrimaryButton
                onClick={() => viewModel.handleOpenAvaliarFuncionarioTreinamentoModal(true)}>
                Avaliar treinamentos
              </PrimaryButton>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="PAGE flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            RH
          </Link>
          <Typography className="text-primary-green">
            Avaliação de Treinamentos em Lote
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Avaliação de Treinamentos em Lote</h1>
            <RefreshButton onClick={viewModel.handleReloadPage} />
          </div>

          <div className="flex flex-row gap-2"></div>
        </div>
        {
          viewModel.errorMessage
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReloadPage} />
              </div>
            ) : (
              <>
                <Header
                  selectedIdCargo={viewModel.filters.selectedIdCargo}
                  cargos={viewModel.filters.cargos ?? []}
                  selectedIdFuncionario={viewModel.filters.selectedIdFuncionario}
                  funcionarios={viewModel.filters.funcionarios ?? []}
                  selectedIdCentroCustos={viewModel.filters.selectedIdCentroCusto}
                  centroCustos={viewModel.filters.centroCustos ?? []}
                  vencimentoDe={viewModel.filters.vencimentoDe}
                  vencimentoAte={viewModel.filters.vencimentoAte}
                  onSelectedCargoChange={viewModel.handleSelectedCargoChange}
                  onSelectedFuncionarioChange={viewModel.handleSelectedFuncionarioChange}
                  onSelectedCentroCustoChange={viewModel.handleSelectedCentroCustoChange}
                  onVencimentoChange={viewModel.handleVencimentoChange}
                  onClearFilters={viewModel.handleClear} />

                <Stack spacing={0} className="mt-4">
                  <div className="w-full flex flex-row justify-between items-end my-4">
                    <LegendComponent>
                      <LegendItemComponent
                        icon={<LegendIcon color='blue' title='D' />}
                        label='Avaliação dentro do prazo' />

                      <LegendItemComponent
                        icon={<LegendIcon color='red' title='A' />}
                        label='Avaliação em atraso' />
                    </LegendComponent>
                  </div>

                  <StyledDataGrid
                    tableName="avaliacao_treinamento_lote"
                    disableColumnMenu={false}
                    disableRowSelectionOnClick={true}
                    checkboxSelection={true}
                    getRowId={(row: AvaliacaoTreinamento) => row.idFuncionarioTreinamento}
                    getRowHeight={() => 'auto'}
                    textSize="pequeno"
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rowSelectionModel={viewModel.rowsSelectionModel}
                    onRowSelectionModelChange={(gridSelectionModel) => viewModel.handleRowsSelectionChange(gridSelectionModel)}
                    rows={viewModel.funcionarioTreinamentos}
                    rowCount={viewModel.funcionarioTreinamentos.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }} />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

                </Stack>
              </>
            )
        }

        <AvaliarTreinamentoModal
          open={viewModel.openAvaliarFuncionarioTreinamentoModal}
          saving={viewModel.saving}
          onSubmit={viewModel.handleSubmitAvaliarTreinamento}
          onClose={viewModel.handleOpenAvaliarFuncionarioTreinamentoModal} />

      </div>
    </>
  );
}